import { takeEvery, put } from 'redux-saga/effects';

import loginActions from '../actionTypes/loginActions';
import { API_CALL } from '../actionTypes/sharedActions';
import { LOGIN_URL } from '../routes';

function* login({ payload }) {
  yield put({
    type: API_CALL,
    payload: {
      url: LOGIN_URL,
      method: 'POST',
      data: payload
    },
    successAction: loginActions.userLoginSuccess,
    failureAction: loginActions.userLoginFailed
  });
}

export default function* watchUserLogin() {
  yield takeEvery(loginActions.userLogin, login);
}
